// extracted by mini-css-extract-plugin
export default {"dropdown_list":"PBrvt","dropdown_list_item":"WtWOk","active":"_5WzH"};